var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffice365(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bg",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -436,
    y: -454,
    display: "inline",
    fill: "#666666",
    width: 851,
    height: 1053
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ED3A00",
    d: "M6.623,51.753c10.939,1.501,21.877,3.001,32.928,4.517c0-15.556,0-30.856,0-46.419 c-7.653,1.826-15.164,3.618-22.824,5.445c0,10.532,0,21.002,0,31.498c-3.809,1.492-7.478,2.928-11.281,4.417 c0-12.897,0-25.65,0-38.544c2.845-1.071,5.76-2.169,8.676-3.264c8.125-3.051,16.256-6.088,24.369-9.169 c0.783-0.297,1.454-0.303,2.241-0.071c5.612,1.654,11.236,3.266,16.855,4.897c0.321,0.093,0.631,0.227,1.017,0.368 c0,17.781,0,35.533,0,53.432c-2.011,0.576-4.01,1.162-6.016,1.719c-3.993,1.109-7.987,2.218-11.991,3.286 c-0.528,0.141-1.181,0.205-1.673,0.025c-10.577-3.873-21.14-7.785-31.705-11.694c-0.22-0.082-0.423-0.21-0.634-0.317 C6.597,51.837,6.61,51.795,6.623,51.753z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "White",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#FFFFFF",
    d: "M6.623,51.753c10.939,1.501,21.877,3.001,32.928,4.517c0-15.556,0-30.856,0-46.419 c-7.653,1.826-15.164,3.618-22.824,5.445c0,10.532,0,21.002,0,31.498c-3.809,1.492-7.478,2.928-11.281,4.417 c0-12.897,0-25.65,0-38.544c2.845-1.071,5.76-2.169,8.676-3.264c8.125-3.051,16.256-6.088,24.369-9.169 c0.783-0.297,1.454-0.303,2.241-0.071c5.612,1.654,11.236,3.266,16.855,4.897c0.321,0.093,0.631,0.227,1.017,0.368 c0,17.781,0,35.533,0,53.432c-2.011,0.576-4.01,1.162-6.016,1.719c-3.993,1.109-7.987,2.218-11.991,3.286 c-0.528,0.141-1.181,0.205-1.673,0.025c-10.577-3.873-21.14-7.785-31.705-11.694c-0.22-0.082-0.423-0.21-0.634-0.317 C6.597,51.837,6.61,51.795,6.623,51.753z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice365);
export default __webpack_public_path__ + "static/media/Office365.6dff17c4cdece74dce4d3f9cf1b09c2c.svg";
export { ForwardRef as ReactComponent };